import { callApi } from "@/api/callApi";
import { API_ENDPOINT } from "@/api/constant";
import type {
  IAttendanceResponse,
  IMarkAttendancePayload,
  IMarkAttendanceResponse,
  IAttendanceLogsResponse,
  IAttendanceOverviewResponse,
  IAttendanceSummaryResponse,
  ILockAttendancePayload,
  ILockAttendanceResponse,
  IPreviewMonthlySalaryPayload,
  ICreateUserMonthlySalaryPayload,
  ICreateUserMonthlySalaryResponse,
  ISalaryPreviewResponse,
  IBulkAttendanceResponse,
} from "@/interface/attendance.interface";

export const AttendanceService = {
  getAttendance: async (params?: string): Promise<IAttendanceResponse> => {
    const API = `${API_ENDPOINT.attendance}${params ? `?${params}` : ""}`;
    return callApi<IAttendanceResponse>(API, { method: "GET" });
  },

  getBulkAttendance: async (
    params?: string
  ): Promise<IBulkAttendanceResponse> => {
    const API = `${API_ENDPOINT.attendance}/bulk${params ? `?${params}` : ""}`;
    return callApi<IBulkAttendanceResponse>(API, { method: "GET" });
  },

  downloadBulkAttendanceReport: async (params?: string): Promise<Blob> => {
    const API = `${API_ENDPOINT.attendance}/bulk/download${params ? `?${params}` : ""}`;
    return callApi<Blob>(API, { method: "GET" });
  },

  getAttendanceLogs: async (
    params?: string,
  ): Promise<IAttendanceLogsResponse> => {
    const API = `${API_ENDPOINT.attendance}/logs${params ? `?${params}` : ""}`;
    return callApi<IAttendanceLogsResponse>(API, { method: "GET" });
  },

  getAttendanceOverview: async (
    params?: string,
  ): Promise<IAttendanceOverviewResponse> => {
    const API = `${API_ENDPOINT.attendance}/overview${params ? `?${params}` : ""}`;
    return callApi<IAttendanceOverviewResponse>(API, { method: "GET" });
  },

  markAttendance: async (
    payload: IMarkAttendancePayload,
    params?: string,
  ): Promise<IMarkAttendanceResponse> => {
    const API = `${API_ENDPOINT.attendance}${params ? `?${params}` : ""}`;
    return callApi<IMarkAttendanceResponse>(API, {
      method: "POST",
      data: payload,
    });
  },

  updateAttendance: async (
    id: string,
    payload: IMarkAttendancePayload,
  ): Promise<IMarkAttendanceResponse> => {
    const API = `${API_ENDPOINT.attendance}/${id}`;
    return callApi<IMarkAttendanceResponse>(API, {
      method: "PUT",
      data: payload,
    });
  },
  getDailyTeamAttendance: async (
    params?: string,
  ): Promise<IAttendanceSummaryResponse> => {
    const API = `/attendance-summary${params ? `?${params}` : ""}`;
    return callApi<IAttendanceSummaryResponse>(API, { method: "GET" });
  },

  downloadDailyAttendanceReport: async (params?: string): Promise<Blob> => {
    const API = `${API_ENDPOINT.attendance}/daily/download${params ? `?${params}` : ""}`;
    return callApi<Blob>(API, { method: "GET" });
  },

  downloadMonthlyAttendanceReport: async (params?: string): Promise<Blob> => {
    const API = `/report/attendance/monthly-users${params ? `?${params}` : ""}`;
    return callApi<Blob>(API, { method: "GET" });
  },

  lockAttendance: async (
    payload: ILockAttendancePayload,
  ): Promise<ILockAttendanceResponse> => {
    const API = `/attendance/lock`;
    return callApi<ILockAttendanceResponse>(API, {
      method: "POST",
      data: payload,
    });
  },

  previewMonthlySalary: async (
    payload: IPreviewMonthlySalaryPayload,
  ): Promise<ISalaryPreviewResponse> => {
    const API = `/preview-user-monthly-salary`;
    return callApi<ISalaryPreviewResponse>(API, {
      method: "POST",
      data: payload,
    });
  },

  createUserMonthlySalary: async (
    payload: ICreateUserMonthlySalaryPayload,
  ): Promise<ICreateUserMonthlySalaryResponse> => {
    const API = `/create-user-monthly-salary`;
    return callApi<ICreateUserMonthlySalaryResponse>(API, {
      method: "POST",
      data: payload,
    });
  },
};
